<template>
<!-- 首页 -->
  <div class="wrap" ref="i1">
    <pageHeader></pageHeader>
    <div class="indexCennert">

      <!-- //在这里除了渲染还要点击拿到id来发送指令给index.vue来弹开弹窗。 -->
            <!-- 监听用户在组件里的点击切换请求 -->
    <indexCennert @handleChange="changeName"></indexCennert>
    </div>
    <pageMarketing></pageMarketing>
    <paheVideo></paheVideo>
    <paheCloud></paheCloud>
    <paheService></paheService>
    <paheCustomers></paheCustomers>
    <paheFooter></paheFooter>
    <!-- 当用户点击了弹窗 popUp_ 代表 弹窗是否打开 codeid是渲染是已经带回来的由indexCennert来发送 close1自定义事件触发后是销毁组件-->
    <!-- //父级收到指令给传参给它打开。且请求渲染 -->
    <popUpwindow v-if="popUp_" :lin_k="link_" :codeid="codeid"   @close1="close1"></popUpwindow>
  </div>
</template>
<script>
//引入的是头部的banner模块
import pageHeader from '@/common/index/page-header'
//引入的是行业解决方案模块
//在这里除了渲染还要点击拿到id来发送指令给index.vue来弹开弹窗。
import indexCennert from '@/common/index/page-cennert'
//引入的是营销功能模块
import pageMarketing from '@/common/index/page-marketing'
//引入的是云展系统模块
import paheCloud from '@/common/index/pahe-cloud'
//引入视频模块
import paheVideo from '@/common/index/pahe-video'
//引入服务流程模块
import paheService from '@/common/index/pahe-service'
//引入联系客户模块
import paheCustomers from '@/common/index/pahe-customers'
//引入底部模块
import paheFooter from '@/common/index/pahe-footer'
//引入案例弹窗
//父级收到指令给传参给它打开。且请求渲染
import popUpwindow from '@/common/public/pop-upwindow'

export default {
  name: 'index',
  data () {
    return {
      // popUp_是打开弹窗
        popUp_:false,
        link_:null,
        codeid:null,
        Pop_up_data:[
        
        ],
        cate2:null
    }
  },
  components:{
      pageHeader,
      indexCennert,
      pageMarketing,
      paheCloud,
      paheVideo, 
      paheService,
      paheCustomers,
      paheFooter,
      popUpwindow
  },
  mounted() {
    var indexTop = localStorage.getItem('index_top');
    document.documentElement.scrollTop = indexTop;
  },
  destroyed() {
    let i1 = document.documentElement.scrollTop;
    localStorage.setItem('index_top', i1)
  },
  methods:{
    //收到indexCennert发送的指令
    changeName(link_){
      this.link_=link_.Model_link
      this.codeid=link_.codeid
      this.popUp_ = true
    },
    close1(){
      this.popUp_ = false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.indexCennert{
  /* opacity: 0.5; */
  animation: myfirst 1s;
}
@keyframes myfirst
{
  from {opacity: 0;}
  to {opacity: 1;}
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue